import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { Client } from '@microsoft/microsoft-graph-client';
var GraphClient = function GraphClient() {
    "use strict";
    var _this = this;
    _class_call_check(this, GraphClient);
    _define_property(this, "cachedGraphClient", null);
    _define_property(this, "get", function(accessToken) {
        if (_this.cachedGraphClient && _this.cachedGraphClient.accessToken === accessToken) {
            return _this.cachedGraphClient.client;
        }
        var authenticationProvider = {
            getAccessToken: function getAccessToken() {
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        // @ts-ignore
                        return [
                            2,
                            accessToken
                        ];
                    });
                })();
            }
        };
        var clientOptions = {
            authProvider: authenticationProvider
        };
        var client = Client.initWithMiddleware(clientOptions);
        _this.cachedGraphClient = {
            accessToken: accessToken,
            client: client
        };
        return client;
    });
    _define_property(this, "flush", function() {
        _this.cachedGraphClient = null;
    });
};
var graphClient = new GraphClient();
export default graphClient;
